/**
 * The shipped dictionaries.
 *
 * Two JSON files, source-controlled, imported directly. Not fetched, not
 * generated, and not in Postgres (V1.md sections 6 and 38): UI copy is code,
 * it changes with the code that renders it, and it has to be reviewable in the
 * same diff.
 *
 * English is the reference shape — `keys.ts` derives `TranslationKey` from it —
 * and `es` is annotated with `Dictionary` so a key added to one file and not
 * the other is a type error here rather than a blank label in production.
 * `dictionaries.test.ts` covers what the type cannot: placeholders that agree,
 * values that are not empty.
 */
import en from './translations/en.json' with { type: 'json' };
import es from './translations/es.json' with { type: 'json' };
import { CATALOG_LOCALES } from './language.js';
import { createTranslatorFor } from './translate.js';
export const DICTIONARIES = {
    en,
    es: es,
};
/** The `t` for one language, over the shipped dictionaries. */
export function createTranslator(language, options = {}) {
    return createTranslatorFor(language, DICTIONARIES[language], options);
}
/** The catalog locale for a language. Re-exported so callers need one import. */
export function catalogLocaleFor(language) {
    return CATALOG_LOCALES[language];
}
//# sourceMappingURL=dictionaries.js.map